import "./DrainCleaning.module.css";
import Header from "@/reusable_sections/Header";
import DrainHero from "./sections/DrainHero";
import DrainOverview from "./sections/DrainOverview";
import DrainProblems from "./sections/DrainProblems";
import DrainSigns from "./sections/DrainSigns";
import DrainDiagnostics from "./sections/DrainDiagnostics";
import RelatedServices from "./sections/RelatedServices";
import RelatedProblems from "./sections/RelatedProblems";
import ServiceArea from "./sections/ServiceArea";
import DrainFaq from "./sections/DrainFaq";
import EmergencyCallout from "./sections/EmergencyCallout";
import Footer from "@/reusable_sections/Footer";
export default function DrainCleaningPage() {
  return <div>
      <Header />
      <DrainHero />
      <DrainOverview />
      <DrainProblems />
      <DrainSigns />
      <DrainDiagnostics />
      <RelatedServices />
      <RelatedProblems />
      <ServiceArea />
      <DrainFaq />
      <EmergencyCallout />
      <Footer />
    </div>;
}